import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class Source {

  public static DEFAULT_SOURCE: string = "CRYSTAL";

  @JsonProperty()
  originCode: string | undefined;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  description: string | undefined;

  @JsonProperty()
  type: Source.SourceType;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}

export module Source {
  export enum SourceType {
    IN = 'IN',
    OUT = 'OUT',
    TICKER = 'TICKER'
  }
}
